import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "tableScoring" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = { class: "page_header" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "formContainer" }
const _hoisted_10 = { class: "table table-striped w-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center mt-4 pt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedConfiguration.totalPointsAndValues, (totalPt, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", {
                    style: _normalizeStyle('background-color: ' + totalPt.color)
                  }, _toDisplayString(totalPt.resultValue), 5),
                  _createElementVNode("td", {
                    style: _normalizeStyle('background-color: ' + totalPt.color)
                  }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(totalPt.minValue) + _toDisplayString(totalPt.maxValue != null ? ', ' + totalPt.maxValue : '+'), 1)
                  ], 4)
                ]))
              }), 128))
            ])
          ]),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-tertiary w-100 mt-5 justify-content-center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editScoringConfig()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Edit Ranking",
                  text: "Edit Ranking"
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary w-100 mt-2 justify-content-center",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyDefaultScoringConfig()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Back to Default",
                  text: "Back to Default"
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_localized_text, {
              type: 'h1',
              localizedKey: "Scoring configuration",
              text: "Scoring configuration",
              class: "mb-0"
            }),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoringTableConfig.tableCategories, (category, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["btn me-2", _ctx.activeSection == category.categoryTitle ? 'btn-tertiary': 'btn-secondary withBorder']),
                  onClick: ($event: any) => (_ctx.activeSection = category.categoryTitle),
                  key: index
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: category.categoryTitle,
                    text: category.categoryTitle
                  }, null, 8, ["localizedKey", "text"])
                ], 10, _hoisted_8))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTableConfiguration.subCategories, (subCat, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: index,
                      class: "text-center"
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: subCat.key,
                        text: subCat.key,
                        type: "strong"
                      }, null, 8, ["localizedKey", "text"])
                    ]))
                  }), 128)),
                  _createElementVNode("td", _hoisted_12, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Total points",
                      text: "Total points",
                      type: "strong"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTableConfiguration.subCategories, (subCat, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: index,
                      class: "text-center"
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(subCat.value), 1)
                    ]))
                  }), 128)),
                  _hoisted_14
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTableConfiguration.certifications, (cert, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: cert.title,
                        text: cert.title
                      }, null, 8, ["localizedKey", "text"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTableConfiguration.subCategories, (subCat, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: index,
                        class: "text-center"
                      }, _toDisplayString(cert.subCategories.filter(x => x.key == subCat.key)[0].value), 1))
                    }), 128)),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.currency(_ctx.getTotalPoints(cert))), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "btn btn-primary me-2 justify-content-center",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyDefaultScoringTableConfig()))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Back to Default",
                      text: "Back to Default"
                    })
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-secondary ms-2 justify-content-center",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editScoringTableCertificationsConfig()))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Edit Certifications",
                      text: "Edit Certifications"
                    })
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-tertiary ms-2 justify-content-center",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editScoringTableCategoriesConfig()))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Edit Categories",
                      text: "Edit Categories"
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}